export default "__VITE_ASSET__e59a80dd__"